import '../../modules/mode-components';

import { getOwnerUsername } from '@mode/shared/util-js';

import { AccountFacade } from '@mode/accounts/contract';
import { OrgTypes } from '@mode/shared/contract-common';
import { takeUntil } from 'rxjs/operators';
import { MixableBaseController } from '~/common/component';
import { AppStore } from '~/types/main.types';
import { BugsnagHelpers } from '../../lib/bugsnag-helpers';

export default class EmailAnAdminController extends MixableBaseController {
  selectedAdmin: OrgTypes.Admin;
  admins: ReadonlyArray<OrgTypes.Admin>;
  msgContents: string;
  emailSuccessful: boolean | null;
  showSpinner: boolean;
  dataSourceConnectionRequestUrl: string;
  org: any;
  workspaceTitle = 'Workspace';

  static $inject = ['$scope', '$window', 'AccountModel', 'ModeCollection', 'RxStoreService', 'AccountFacade'];

  constructor(
    private $scope,
    private $window: angular.IWindowService,
    private AccountModel,
    private ModeCollection,
    private rxStoreService: AppStore,
    private accountFacade: AccountFacade
  ) {
    super();
  }

  $onInit() {
    this.accountFacade.loadAdminsForEmailForm();
    this.accountFacade.admins$.pipe(takeUntil(this.destroyed$)).subscribe((admins) => {
      this.admins = admins;
      this.selectedAdmin = admins[0];
    });

    // Get the organization
    this.AccountModel.find({
      username: getOwnerUsername(this.$window.document),
      useEntryPath: true,
      refresh: true,
    }).then((accountReturn) => {
      // store the organization
      this.org = accountReturn;
      // parse and return the admins
      // return accountReturn.admins().then(this.ModeCollection.elements);

      this.msgContents = `I'd like to connect data to our ${this.workspaceTitle}, but only admins have permission to create new data connections. Can you help?`;
      this.emailSuccessful = null;
    });
  }

  changeSelectedAdmin(id) {
    this.selectedAdmin = this.admins.find((admin) => admin.id === id);
  }

  changeMessage(msg) {
    this.msgContents = msg;
  }

  sendEmailToAdmin() {
    this.showSpinner = true;

    const params = {
      admin_id: this.selectedAdmin.id,
      email_body: this.msgContents,
    };
    this.org._resource
      .links('data_source_connection_request_web')
      .$follow(null, null, { method: 'POST', data: params })
      .then(() => {
        this.showSpinner = false;
        this.emailSuccessful = true;
      })
      .catch((err) => {
        console.error(err);
        BugsnagHelpers.notifySafely(err);
        this.showSpinner = false;
        this.emailSuccessful = false;
      });
  }
}
